import { useEffect, useState } from "react";

import { Button } from "../../../Components/Buttons";
import { FormInput, FormSection } from "../../../Components/Form";
import { ToastMessage } from "../../../Components/Utils";
import {
  useFetchSocialLinksAllQuery,
  useCreateSocialLinkMutation,
  useUpdateSocialLinkMutation,
} from "../../../stores/api/socialLinks.api";

const PLATFORMS = [
  {
    key: "facebook",
    label: "Facebook",
    placeholder: "https://facebook.com/yourpage",
    icon: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M22 12c0-5.522-4.477-10-10-10S2 6.478 2 12c0 4.991 3.657 9.128 8.438 9.878V14.89h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"/>
      </svg>
    ),
    color: "text-blue-600 dark:text-blue-400",
  },
  {
    key: "instagram",
    label: "Instagram",
    placeholder: "https://instagram.com/yourhandle",
    icon: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.366.062 2.633.334 3.608 1.308.975.975 1.246 2.242 1.308 3.608.058 1.266.07 1.646.07 4.85s-.012 3.584-.07 4.85c-.062 1.366-.334 2.633-1.308 3.608-.975.975-2.242 1.246-3.608 1.308-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.366-.062-2.633-.334-3.608-1.308-.975-.975-1.246-2.242-1.308-3.608C2.175 15.584 2.163 15.204 2.163 12s.012-3.584.07-4.85c.062-1.366.334-2.633 1.308-3.608C4.516 2.497 5.783 2.225 7.15 2.163 8.416 2.105 8.796 2.163 12 2.163zm0-2.163C8.741 0 8.332.014 7.052.072 5.197.157 3.355.74 2.014 2.08.674 3.42.157 5.197.072 7.052.014 8.332 0 8.741 0 12c0 3.259.014 3.668.072 4.948.085 1.855.602 3.632 1.942 4.972 1.34 1.34 3.117 1.857 4.972 1.942C8.332 23.986 8.741 24 12 24s3.668-.014 4.948-.072c1.855-.085 3.632-.602 4.972-1.942 1.34-1.34 1.857-3.117 1.942-4.972.058-1.28.072-1.689.072-4.948s-.014-3.668-.072-4.948c-.085-1.855-.602-3.632-1.942-4.972C20.58.74 18.803.157 16.948.072 15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
      </svg>
    ),
    color: "text-pink-500 dark:text-pink-400",
  },
  {
    key: "whatsapp",
    label: "WhatsApp",
    placeholder: "https://wa.me/1234567890",
    icon: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 00-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
      </svg>
    ),
    color: "text-green-500 dark:text-white-400",
  },
  {
    key: "x",
    label: "X (Twitter)",
    placeholder: "https://x.com/yourhandle",
    icon: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
      </svg>
    ),
    color: "text-gray-800 dark:text-gray-200",
  },
  {
    key: "linkedin",
    label: "LinkedIn",
    placeholder: "https://linkedin.com/company/yourcompany",
    icon: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
      </svg>
    ),
    color: "text-blue-700 dark:text-blue-400",
  },
  {
    key: "github",
    label: "GitHub",
    placeholder: "https://github.com/yourorg",
    icon: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12"/>
      </svg>
    ),
    color: "text-gray-700 dark:text-gray-300",
  },
];

const EMPTY = Object.fromEntries(PLATFORMS.map(p => [p.key, ""]));

const SocialLinksSettings = () => {
  const [formData, setFormData] = useState(EMPTY);
  const [prefilled, setPrefilled] = useState(false);
  const { data: existingLinks, isLoading } = useFetchSocialLinksAllQuery();
  const [createLink, { isLoading: isCreating }] = useCreateSocialLinkMutation();
  const [updateLink, { isLoading: isUpdating }] = useUpdateSocialLinkMutation();

  const isSaving = isCreating || isUpdating;

  useEffect(() => {
    if (existingLinks && !prefilled) {
      const links = Array.isArray(existingLinks) ? existingLinks : (existingLinks.data || existingLinks.rows || []);
      const mapped = { ...EMPTY };
      links.forEach((link) => {
        mapped[link.name] = link.link || "";
      });
      setFormData(mapped);
      setPrefilled(true);
    }
  }, [existingLinks, prefilled]);

  const onSubmit = async (e) => {
    e.preventDefault();
    const linksArr = Array.isArray(existingLinks) ? existingLinks : (existingLinks?.data || existingLinks?.rows || []);
    const existingMap = {};
    linksArr.forEach((link) => {
      existingMap[link.name] = { id: link.id };
    });

    const results = [];
    for (const platform of PLATFORMS) {
      const url = (formData[platform.key] || "").trim();
      const existing = existingMap[platform.key];

      if (!url && !existing) continue;

      if (existing) {
        if (url) {
          results.push(
            updateLink({ id: existing.id, body: { name: platform.key, icon: platform.key, link: url, status: true } }).unwrap()
          );
        } else {
          // empty = disable without clearing URL (schema requires valid URL)
          results.push(
            updateLink({ id: existing.id, body: { status: false } }).unwrap()
          );
        }
      } else if (url) {
        results.push(
          createLink({ name: platform.key, icon: platform.key, link: url, status: true }).unwrap()
        );
      }
    }

    try {
      await Promise.all(results);
      // keep current inputs populated; refetch reconciles in background without wiping the form
      ToastMessage({ type: "success", title: "Success", message: "Social links saved!" });
    } catch (err) {
      ToastMessage({ type: "error", title: "Error!", message: err?.data?.message || err?.message || "Something went wrong" });
    }
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-20">
        <span className="w-6 h-6 border-2 border-green-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <form onSubmit={onSubmit} className="mx-auto dark:bg-slate-900 rounded-lg p-6 space-y-5">
      <FormSection title="Social Media Links">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {PLATFORMS.map((platform) => (
            <div key={platform.key} className="flex items-start gap-3">
              <span className={`mt-8 flex-shrink-0 ${platform.color}`}>
                {platform.icon}
              </span>
              <FormInput
                label={platform.label}
                name={platform.key}
                value={formData[platform.key]}
                onChange={(val) => setFormData(prev => ({ ...prev, [platform.key]: val }))}
                placeholder={platform.placeholder}
                className="flex-1"
              />
            </div>
          ))}
        </div>
      </FormSection>

      <div className="flex items-center justify-end gap-3 pt-2">
        <Button
          type="submit" loading={isSaving} disabled={isSaving}
          className="!bg-green-500 !text-white hover:!bg-green-600"
          loadingText="Saving..."
        >
          Save Links
        </Button>
      </div>
    </form>
  );
};

export default SocialLinksSettings;
